<div [formGroup]="form" class="detail-right-column">
   @if (showCards) {
   <ndt-card [title]="'General Information'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="generalInfoFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half">
      <mat-label>Extension Number</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extension?.number"
         [formControl]="parentFormGroup.get('number')"
         required
         id="a548a982-17d2-4bee-9fa9-e2df166087e7"
      />
      @if (parentFormGroup.get('number')?.hasError('required')) {
      <mat-error> Number Field is Required. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('pattern')) {
      <mat-error> Invalid Number Format </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
      <mat-error> Number must be between 100-99999. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
      <mat-error> Extension number already in use. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.name"
         [formControl]="parentFormGroup.get('name')"
         required
         id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
      />
      @if (parentFormGroup.get('name')?.hasError('required')) {
      <mat-error> Name Field is Required. </mat-error>
      } @if ( !parentFormGroup.get('name')?.hasError('required') && parentFormGroup.get('name')?.hasError('noContent') )
      {
      <mat-error> Name must contain characters. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Short Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.shortName"
         [formControl]="parentFormGroup.get('shortName')"
         id="1785939f-8f84-47c8-a1d1-de065119a360"
      />
      @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
      <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
      }
   </mat-form-field>
   }
   <ng-template #generalInfoFields>
      <mat-form-field class="flex-half">
         <mat-label>Extension Number</mat-label>
         <input
            matInput
            autocomplete="off"
            type="tel"
            [value]="extension?.number"
            [formControl]="parentFormGroup.get('number')"
            required
            id="a548a982-17d2-4bee-9fa9-e2df166087e7"
         />
         @if (parentFormGroup.get('number')?.hasError('required')) {
         <mat-error> Number Field is Required. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('pattern')) {
         <mat-error> Invalid Number Format </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
         <mat-error> Number must be between 100-99999. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
         <mat-error> Extension number already in use. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.name"
            [formControl]="parentFormGroup.get('name')"
            required
            id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
         />
         @if (parentFormGroup.get('name')?.hasError('required')) {
         <mat-error> Name Field is Required. </mat-error>
         } @if ( !parentFormGroup.get('name')?.hasError('required') &&
         parentFormGroup.get('name')?.hasError('noContent') ) {
         <mat-error> Name must contain characters. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Short Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.shortName"
            [formControl]="parentFormGroup.get('shortName')"
            id="1785939f-8f84-47c8-a1d1-de065119a360"
         />
         @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
         <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
         }
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Notes'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="notesFields"></ng-container>
   </ndt-card>
   }
   <ng-template #notesFields>
      @if (isSystemUser) {
      <mat-form-field class="flex-half">
         <mat-label>Admin Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('adminNotes')"
            id="extension-phone-dnd-status"
         ></textarea>
      </mat-form-field>
      }
      <mat-form-field [ngClass]="{ 'flex-full': !isSystemUser, 'flex-half': isSystemUser }">
         <mat-label>Extension Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('extensionNotes')"
            id="extension-phone-dnd-status"
            [readonly]="isSystemUser"
         ></textarea>
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Settings'" class="detail-card">
      <ng-container *ngTemplateOutlet="settingsFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half">
      <mat-label>Default Phone Number *</mat-label>
      <input
         [lcsSingleSelect]="phoneNumberSelect"
         [accountId]="accountId"
         ndtPhoneNumberSelect
         autocomplete="off"
         type="text"
         formControlName="defaultPhoneNumber"
         id="extension-fmfm-default-phone-number"
      />
      <ndt-phone-number-select #phoneNumberSelect [onlyAllowOutboundCallsNumbers]="true"></ndt-phone-number-select>
      @if (form.get('defaultPhoneNumber')?.hasError('required')) {
      <mat-error> Default Phone Number is Required. </mat-error>
      }
   </mat-form-field>
   @if (accountId) {
   <mat-form-field class="flex-half">
      <mat-label>Location</mat-label>
      <input
         autocomplete="off"
         type="text"
         [lcsSingleSelect]="locationSelect"
         ndtLocationSelect
         [accountId]="accountId"
         [formControl]="parentFormGroup.get('location')"
         id="location"
      />
      <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
   </mat-form-field>
   }
   <mat-form-field class="flex-half">
      <mat-label>Time Zone</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="timeZoneSelect"
         ndtTimeZoneSelect
         autocomplete="off"
         type="text"
         [formControl]="parentFormGroup.get('timeZone')"
         id="extension-phone-time-zone"
         [placeholder]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      />
      <ndt-time-zone-select
         #timeZoneSelect
         isIncludeEmptyOption="true"
         [overrideEmptyOption]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      ></ndt-time-zone-select>
   </mat-form-field>
   <div class="flex-container flex-full">
      <div class="final-destination-group">
         <mat-label class="destination-type-label">Final Destination Type</mat-label>
         <mat-radio-group formControlName="destinationType" class="destination-type-radio-group">
            <mat-radio-button color="primary" value="extension">Extension</mat-radio-button>
            <mat-radio-button color="primary" value="phoneNumber">Phone Number</mat-radio-button>
         </mat-radio-group>
      </div>
      @if (form.get('destinationType')?.value === 'extension') {
      <div class="flex-container flex-half">
         <mat-form-field class="flex-half">
            <mat-label>Final Destination Extension</mat-label>
            <input
               [lcsSingleSelect]="finalDestExtensionSelect"
               [accountId]="accountId"
               ndtExtensionSelect
               autocomplete="off"
               type="text"
               [extensionTypesToExclude]="[7]"
               formControlName="finalDestinationExtension"
               id="extension-fmfm-final-destination-extension"
               required
            />
            @if (form.hasError('requiredDestination')) {
            <mat-error> Final Destination Extension is required. </mat-error>
            }
            <ndt-extension-select #finalDestExtensionSelect></ndt-extension-select>
         </mat-form-field>
         <div class="right-align-radio-group" [hidden]="!finalDestinationExtensionTypePhone">
            <mat-radio-group formControlName="isFinalDestinationVoicemail">
               <div>
                  <mat-radio-button
                     class="fmfm-radio-button"
                     [value]="false"
                     [hidden]="!finalDestinationExtensionTypePhone"
                     color="primary"
                     >Phone</mat-radio-button
                  >
                  <mat-radio-button
                     color="primary"
                     class="fmfm-radio-button"
                     [value]="true"
                     [hidden]="!finalDestinationExtensionTypePhone"
                     >Voicemail</mat-radio-button
                  >
               </div>
            </mat-radio-group>
         </div>
      </div>
      } @if (form.get('destinationType')?.value === 'phoneNumber') {
      <div class="flex-container flex-half">
         <mat-form-field class="flex-half">
            <mat-label>Final Destination Phone Number</mat-label>
            <input matInput autocomplete="off" type="tel" formControlName="finalDestinationPhoneNumber" required />
            @if (form.hasError('requiredDestination')) {
            <mat-error> Final Destination Phone Number is required. </mat-error>
            } @if (form.get('finalDestinationPhoneNumber')?.hasError('pattern')) {
            <mat-error> Please enter a valid phone number. </mat-error>
            }
         </mat-form-field>
      </div>
      }
   </div>
   <mat-checkbox class="flex-full" formControlName="isIgnoreForward" id="extension-fmfm-isIgnoreForward">
      Ignore Forwarding?
   </mat-checkbox>
   <mat-checkbox class="flex-full" formControlName="isGreetingDisabled" id="extension-fmfm-greeting-disabled">
      Disable Greeting?
   </mat-checkbox>
   <mat-checkbox class="flex-full" formControlName="isSendOriginalCallerId" id="extension-fmfm-original-callerid">
      Send Original Caller ID?
   </mat-checkbox>
   }
   <ng-template #settingsFields>
      <mat-form-field class="flex-half">
         <mat-label>Default Phone Number *</mat-label>
         <input
            [lcsSingleSelect]="phoneNumberSelect"
            [accountId]="accountId"
            ndtPhoneNumberSelect
            autocomplete="off"
            type="text"
            formControlName="defaultPhoneNumber"
            id="extension-fmfm-default-phone-number"
         />
         <ndt-phone-number-select #phoneNumberSelect [onlyAllowOutboundCallsNumbers]="true"></ndt-phone-number-select>
         @if (form.get('defaultPhoneNumber')?.hasError('required')) {
         <mat-error> Default Phone Number is Required. </mat-error>
         }
      </mat-form-field>
      @if (accountId) {
      <mat-form-field class="flex-half">
         <mat-label>Location</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="locationSelect"
            ndtLocationSelect
            [accountId]="accountId"
            [formControl]="parentFormGroup.get('location')"
            id="location"
         />
         <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
      </mat-form-field>
      }
      <mat-form-field class="flex-half">
         <mat-label>Time Zone</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="timeZoneSelect"
            ndtTimeZoneSelect
            autocomplete="off"
            type="text"
            [formControl]="parentFormGroup.get('timeZone')"
            id="extension-phone-time-zone"
            [placeholder]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         />
         <ndt-time-zone-select
            #timeZoneSelect
            isIncludeEmptyOption="true"
            [overrideEmptyOption]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         ></ndt-time-zone-select>
      </mat-form-field>
      <div class="flex-container flex-full">
         <div class="final-destination-group">
            <mat-label class="destination-type-label">Final Destination Type</mat-label>
            <mat-radio-group formControlName="destinationType" class="destination-type-radio-group">
               <mat-radio-button color="primary" value="extension">Extension</mat-radio-button>
               <mat-radio-button color="primary" value="phoneNumber">Phone Number</mat-radio-button>
            </mat-radio-group>
         </div>
         @if (form.get('destinationType')?.value === 'extension') {
         <div class="flex-container flex-half">
            <mat-form-field class="flex-half">
               <mat-label>Final Destination Extension</mat-label>
               <input
                  [lcsSingleSelect]="finalDestExtensionSelect"
                  [accountId]="accountId"
                  ndtExtensionSelect
                  autocomplete="off"
                  type="text"
                  [extensionTypesToExclude]="[7]"
                  formControlName="finalDestinationExtension"
                  id="extension-fmfm-final-destination-extension"
                  required
               />
               @if (form.hasError('requiredDestination')) {
               <mat-error> Final Destination Extension is required. </mat-error>
               }
               <ndt-extension-select #finalDestExtensionSelect></ndt-extension-select>
            </mat-form-field>
            <div class="right-align-radio-group" [hidden]="!finalDestinationExtensionTypePhone">
               <mat-radio-group formControlName="isFinalDestinationVoicemail">
                  <div>
                     <mat-radio-button
                        class="fmfm-radio-button"
                        [value]="false"
                        [hidden]="!finalDestinationExtensionTypePhone"
                        color="primary"
                        >Phone</mat-radio-button
                     >
                     <mat-radio-button
                        color="primary"
                        class="fmfm-radio-button"
                        [value]="true"
                        [hidden]="!finalDestinationExtensionTypePhone"
                        >Voicemail</mat-radio-button
                     >
                  </div>
               </mat-radio-group>
            </div>
         </div>
         } @if (form.get('destinationType')?.value === 'phoneNumber') {
         <div class="flex-container flex-half">
            <mat-form-field class="flex-half">
               <mat-label>Final Destination Phone Number</mat-label>
               <input matInput autocomplete="off" type="tel" formControlName="finalDestinationPhoneNumber" required />
               @if (form.hasError('requiredDestination')) {
               <mat-error> Final Destination Phone Number is required. </mat-error>
               } @if (form.get('finalDestinationPhoneNumber')?.hasError('pattern')) {
               <mat-error> Please enter a valid phone number. </mat-error>
               }
            </mat-form-field>
         </div>
         }
      </div>
      <mat-checkbox class="flex-full" formControlName="isIgnoreForward" id="extension-fmfm-isIgnoreForward">
         Ignore Forwarding?
      </mat-checkbox>
      <mat-checkbox class="flex-full" formControlName="isGreetingDisabled" id="extension-fmfm-greeting-disabled">
         Disable Greeting?
      </mat-checkbox>
      <mat-checkbox class="flex-full" formControlName="isSendOriginalCallerId" id="extension-fmfm-original-callerid">
         Send Original Caller ID?
      </mat-checkbox>
   </ng-template>
</div>
